/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

const SPACING = '0.5em';

export const Segment = styled.span({
  color: token('color.text'),
  display: 'inline-block',
});

export const Separator = styled.span({
  marginLeft: SPACING,
  marginRight: SPACING,
});

// !important is needed to override AK Button's use of !important to set the color
// for appearance="link" or appearance="subtle-link"
export const ExpanderWrapper = styled.span`
  & > button {
    color: ${token('color.text')} !important;
  }
`;
